﻿import { nsData } from "@/ServerTypes/Namespaces";
import { LookupEditorBase, LookupEditorOptions } from "@serenity-is/corelib";

export class ViewLookupEditor extends LookupEditorBase<ViewLookupEditorOptions, any> {
    static override[Symbol.typeInfo] = this.registerEditor(nsData);

    constructor(props: { element?: any } & ViewLookupEditorOptions) {
        super(props);
    }

    protected override getLookupKey() {
        return "ViewLookup." + this.options.viewName;
    }
}

export interface ViewLookupEditorOptions extends LookupEditorOptions {
    viewName: string;

}
